import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientesService } from '../../../services/Clientes.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-historial-telefono',
  templateUrl: './historial-telefono.component.html',
  styleUrls: ['./historial-telefono.component.css']
})
export class HistorialTelefonoComponent implements OnInit {
  @Input() cliente: { cliente: string, ID: number };
  historial: Observable<any[]>;

  constructor(
    public activeModal: NgbActiveModal,
    private clientesService: ClientesService
  ) { }

  ngOnInit() {
    this.historial = this.clientesService.historialTelefonos(this.cliente.ID)
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/historial-telefono/historial-telefono.component.ts